import cn from '@repo/shared/utils/cn';
import type { FuelType, VehicleType } from '@/api';
import { FuelTypeChip, getFuelChipStyle } from './FuelTypeChip';

export interface AvatarProps {
	iconUrl: string;
	vehicleType: VehicleType;
	fuelType: FuelType;
}

export const Avatar = ({ iconUrl, vehicleType, fuelType }: AvatarProps) => {
	const isFuelTypeApplicable = getFuelChipStyle(fuelType);
	return (
		<div className="size-[60px] shrink-0 rounded-10 overflow-hidden flex flex-col relative">
			<div
				className={cn(
					'flex items-center justify-center size-50px',
					isFuelTypeApplicable ? 'mx-auto' : 'm-auto',
				)}
			>
				<img
					src={iconUrl}
					alt={vehicleType || 'Vehicle'}
					className="max-w-full max-h-full object-cover"
				/>
			</div>
			{isFuelTypeApplicable && (
				<FuelTypeChip
					fuelType={fuelType}
					className="absolute bottom-0 left-0"
				/>
			)}
		</div>
	);
};
